"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var rest_1 = __importDefault(require("../../rest"));
var learningPathsApi_1 = require("../mock/learningPathsApi");
var coreServiceUrl = process.env.CB_CORE_SERVICE_SERVER_URL;
var learningPathApi = {
    getNextLearningPathItem: function (token, learningPathNodeUuid, contentType, contentUuid, skillTreeUuid) {
        return rest_1.default.get({
            mockFunc: function () { return ({
                success: true,
                nextItemUrl: "/courses/go/lessons/sql_injection?learningPathNodeUuid=".concat(learningPathNodeUuid).concat(skillTreeUuid ? "&skillTreeUuid=".concat(skillTreeUuid) : '', "}"),
                containerUrl: skillTreeUuid ? "/app/skillTree?uuid=".concat(skillTreeUuid) : '/app/learningPath?uuid=123',
                containerName: 'Security Champion',
                isLastItem: false,
            }); },
            url: "".concat(coreServiceUrl, "/learning-path/next-item?learningPathNodeUuid=").concat(learningPathNodeUuid, "&itemType=").concat(contentType, "&itemUuid=").concat(contentUuid).concat(skillTreeUuid ? "&skillTreeUuid=".concat(skillTreeUuid) : ''),
            token: token,
        });
    },
    getLearningPaths: function (token) {
        return rest_1.default.get({
            mockFunc: function () { return learningPathsApi_1.mockLearningPaths; },
            url: "".concat(coreServiceUrl, "/learning-paths"),
            token: token,
        });
    },
    getUserLearningPath: function (learningPathUuid, token) {
        return rest_1.default.get({
            mockFunc: function () { return (__assign(__assign({}, learningPathsApi_1.mockUserLearningPath), { uuid: learningPathUuid })); },
            url: "".concat(coreServiceUrl, "/user-learning-path/").concat(learningPathUuid),
            token: token,
        });
    },
    selectNode: function (token, nodeUuid) {
        return rest_1.default.post({
            mockFunc: function () { return ({ success: true }); },
            url: "".concat(coreServiceUrl, "/learning-path/select-node"),
            body: { nodeUuid: nodeUuid },
            token: token,
        });
    },
    start: function (token, learningPathUuid) {
        return rest_1.default.post({
            mockFunc: function () { return ({ success: true }); },
            url: "".concat(coreServiceUrl, "/learning-path/start"),
            body: { learningPathUuid: learningPathUuid },
            token: token,
        });
    },
    selectLanguages: function (token, categories) {
        return rest_1.default.post({
            mockFunc: function () { return ({ success: true }); },
            url: "".concat(coreServiceUrl, "/user-languages"),
            body: { categories: categories },
            token: token,
        });
    },
    getUserLanguages: function (token) {
        return rest_1.default.get({
            mockFunc: function () { return learningPathsApi_1.mockUserLanguages; },
            url: "".concat(coreServiceUrl, "/user-languages"),
            token: token,
        });
    },
    getLearningPathOverview: function (learningPathUuid, token) {
        return rest_1.default.get({
            mockFunc: function () { return learningPathsApi_1.mockLearningPathOverview; },
            url: "".concat(coreServiceUrl, "/learning-path-overview/").concat(learningPathUuid),
            token: token,
        });
    },
};
exports.default = learningPathApi;
